import React from "react";
import { Iconsvg } from "@wk/components-react16";

function ContactBanner() {
  return (
    <div className="contact-footer-wrapper">
    <div className="contact-footer">
      <h3>Sie möchten uns anrufen?</h3>
      <p>Unser Kundenservice steht Ihnen zu allen vertraglichen, technischen und anwendungsbezogenen Fragen zur
        Verfügung.</p>
      <div className="contact-footer-details">
        <span aria-hidden="true">
          <Iconsvg name="phone"/>
          <a className="formatting-hidden" href={"tel:" + "+49223337607050"}>
            +49 (2233) 3760-7050
          </a>
        </span>
        <span aria-hidden="true">
          <Iconsvg name="clock"/>
          Mo - Fr: 8.00 - 17.00 Uhr
        </span>
      </div>
      <p>Ausgenommen bundeseinheitliche Feiertage, Heiligabend und Silvester.</p>
    </div>
  </div>
  );
}

export default ContactBanner;
